import Vue from 'vue';
import { Carousel, Slide } from 'vue-carousel';
Vue.component('MdmCarousel', Carousel);
Vue.component('MdmSlide', Slide);